export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1770910452211-2e8fd91bc347?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjByb29maW5nJTIwYnVpbGRpbmclMjBleHRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3ODgyNzAxNjd8MA&ixlib=rb-4.1.0&q=85",
  modern: "https://images.unsplash.com/photo-1605942729610-4dc90428d010?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjByb29maW5nJTIwYnVpbGRpbmclMjBleHRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3ODgyNzAxNjd8MA&ixlib=rb-4.1.0&q=85",
  worker: "https://images.unsplash.com/photo-1722619734320-9daad59bac19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxyb29mJTIwd29ya2VyJTIwd2F0ZXJwcm9vZmluZyUyMHdvcmtlciUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlciUyMGFyY2hpdGVjdHVyYWwlMjBkZXRhaWx8ZW58MHx8fHwxNzg4MjcwMTY3fDA&ixlib=rb-4.1.0&q=85",
  harness: "https://images.unsplash.com/photo-1691571026798-1c5819901996?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxyb29mJTIwd29ya2VyJTIwd2F0ZXJwcm9vZmluZyUyMHdvcmtlciUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlciUyMGFyY2hpdGVjdHVyYWwlMjBkZXRhaWx8ZW58MHx8fHwxNzg4MjcwMTY3fDA&ixlib=rb-4.1.0&q=85",
  sunset: "https://images.unsplash.com/photo-1601658797866-7ae55d05a817?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxob3VzZSUyMHJvb2YlMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMHN1bnNldHxlbnwwfHx8fDE3ODgyNzAxNzN8MA&ixlib=rb-4.1.0&q=85",
  residential: "https://images.unsplash.com/photo-1583345237708-add35a664d77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxob3VzZSUyMHJvb2YlMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMHN1bnNldHxlbnwwfHx8fDE3ODgyNzAxNzN8MA&ixlib=rb-4.1.0&q=85",
  contemporary: "https://images.unsplash.com/photo-1606312245296-cc7a82fddb98?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxob3VzZSUyMHJvb2YlMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZSUyMHN1bnNldHxlbnwwfHx8fDE3ODgyNzAxNzN8MA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
  "Couverture ardoise & zinc",
  "Étanchéité toitures terrasses",
  "Isolation & bardage",
  "Sarking",
  "Zinguerie",
  "Photovoltaïque",
  "Garantie décennale AXA",
];

export const SERVICES = [
  {
    id: "couverture",
    num: "01",
    title: "Couverture",
    tag: "Ardoise · Zinc",
    desc: "Construction neuve ou rénovation : nos compagnons posent couvertures ardoise et zinc sur Pontivy et sa région, avec le soin des couvreurs d'expérience.",
    features: ["Ardoise naturelle & fibro-ciment", "Couverture zinc mono-pente", "Neuf & rénovation", "Particuliers, promoteurs, collectivités"],
    image: IMAGES.sunset,
  },
  {
    id: "etancheite",
    num: "02",
    title: "Étanchéité",
    tag: "Terrasses & cintrées",
    desc: "Membranes d'étanchéité pour toitures terrasses, plates ou cintrées — la signature des architectures contemporaines, posée par nos étancheurs qualifiés.",
    features: ["Toitures terrasses et plates", "Toitures cintrées", "Membranes haute performance", "Assurance AXA — métier d'étancheur"],
    image: IMAGES.worker,
  },
  {
    id: "isolation",
    num: "03",
    title: "Isolation & bardage",
    tag: "Sarking · ITE",
    desc: "Isolation thermique et acoustique par l'extérieur, pose de bardage tous matériaux : joindre l'utile à l'agréable pour un bâtiment plus confortable.",
    features: ["Sarking — isolation par le toit", "Isolation thermique & acoustique", "Bardage tous matériaux", "Certification RGE"],
    image: IMAGES.contemporary,
  },
  {
    id: "zinguerie",
    num: "04",
    title: "Zinguerie & accessoires",
    tag: "Gouttières · Fenêtres de toit",
    desc: "Changement de gouttières, installation de fenêtres de toit, ventilation et installations photovoltaïques : tous les accessoires de votre toiture.",
    features: ["Changement de gouttières", "Fenêtres de toit", "Ventilation de toiture", "Installations photovoltaïques"],
    image: IMAGES.harness,
  },
];

export const URGENCE = {
  id: "entretien",
  num: "05",
  title: "Réparations & entretien",
  tag: "À votre service",
  desc: "Réparations de couverture, changement de gouttières, remplacement de fenêtres de toit : nos équipes interviennent rapidement sur Pontivy et sa région.",
  features: ["Réparations de couverture", "Gouttières & descentes", "Fenêtres de toit & ventilation", "Devis gratuit sous 48 h"],
};

export const PROJECTS = [
  { id: 1, title: "Église de Guerlédan", category: "couverture", work: "Couverture ardoise — patrimoine", location: "Guerlédan (22)", detail: "Couverture ardoise complète sur édifice patrimonial.", image: IMAGES.sunset },
  { id: 2, title: "Office notarial", category: "renovation", work: "Couverture, étanchéité & zinguerie", location: "Pontivy (56)", detail: "Réfection complète : couverture, étanchéité et zinguerie.", image: IMAGES.residential },
  { id: 3, title: "Bureaux TB Invest", category: "etancheite", work: "Bardage & étanchéité", location: "Saint-Allouestre (56)", detail: "Bardage extérieur et étanchéité de bureaux.", image: IMAGES.modern },
  { id: 4, title: "Maison contemporaine", category: "couverture", work: "Couverture zinc mono-pente", location: "Morbihan (56)", detail: "Couverture zinc en construction neuve.", image: IMAGES.contemporary },
  { id: 5, title: "Toiture cintrée", category: "etancheite", work: "Membrane d'étanchéité", location: "Côtes d'Armor (22)", detail: "Étanchéité de toiture cintrée.", image: IMAGES.worker },
  { id: 6, title: "Rénovation & sarking", category: "renovation", work: "Isolation rampants sarking", location: "Neulliac (56)", detail: "Isolation des rampants par l'extérieur (sarking).", image: IMAGES.harness },
];

export const TESTIMONIALS = [
  {
    quote: "Je suis très satisfaite du confort que m'apporte l'isolation des rampants de mon toit (sarking). Je n'avais jamais pu obtenir une telle température à l'étage de mon habitation.",
    name: "Chantal",
    role: "Neulliac (56)",
  },
  {
    quote: "Nous choisir, c'est faire le choix de la qualité de services, du conseil, des délais respectés et d'avoir un interlocuteur à votre écoute tout au long de vos travaux.",
    name: "Pierre-Yves Le Roch",
    role: "Gérant",
  },
  {
    quote: "Pour votre sérénité, nos prestations sont garanties par notre assureur AXA en responsabilité civile et décennale.",
    name: "Pierre-Yves Le Roch",
    role: "Gérant",
  },
];

export const STATS = [
  { value: "1993", label: "année de création" },
  { value: "14", label: "compagnons & chargés de projet" },
  { value: "4", label: "départements couverts" },
  { value: "AXA", label: "garantie décennale" },
];
